
import { useEffect, useState } from 'react';
import './styles.css';
import ReactApexChart from 'react-apexcharts';
import { Alert, Col, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import api from '../../../../../../services/axiosConfig';
import { formatarMoedaDolar } from '../../../../../../utils/formatMoeda';

function ChartView() {
    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                height: 350,
                type: 'area',
                toolbar: {
                    show: true,
                },
            },
            colors: ['#00E396', '#008FFB'],

            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'datetime',
                categories: [] 
            },
            yaxis: [
                {
                    // Eixo Y da Esquerda (para a primeira série: Receita)
                    title: {
                        text: "Receita ($)"
                    },
                    labels: {
                        formatter: function (value) {
                            return `$ ${formatarMoedaDolar(Number(value))}`;
                        }
                    }
                }
            ],
            tooltip: {
                x: {
                    format: 'dd/MM/yyyy' 
                },
                y: {
                    formatter: (value, { seriesIndex }) => {
                        if (seriesIndex === 0) {
                            return `$ ${formatarMoedaDolar(value)}`;
                        }
                        return value.toLocaleString('en-US');
                    }
                }
            },
        },
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [totals, setTotals] = useState({ receita: 0, impressoes: 0 });

    const [selectedPeriod, setSelectedPeriod] = useState('mes_atual');

    const periods = [
        { label: "Mês atual", value: "mes_atual" },
        { label: "1 Mês", value: "1m" },
        { label: "3 Meses", value: "3m" },
        { label: "6 Meses", value: "6m" },
        { label: "1 Ano", value: "1a" },
    ];

    useEffect(() => {
        const fetchChartData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await api.get(`/admin/receitas/relatorio/${selectedPeriod}`)
                const { data, totalReceita, totalImpressoes } = response.data;

                const categories = data.map(item => item.date);
                const receitasData = data.map(item => item.receita);

                setChartData({
                    series: [
                        { name: 'Receita ($)', data: receitasData },
                    ],
                    options: {
                        ...chartData.options,
                        xaxis: {
                            ...chartData.options.xaxis,
                            categories: categories 
                        }
                    }
                });
                setTotals({ receita: totalReceita, impressoes: totalImpressoes });

            } catch (err) {
                console.error("Erro ao buscar dados do gráfico:", err);
                setError("Não foi possível carregar os dados. Tente novamente mais tarde.");
            } finally {
                setLoading(false);
            }
        };

        fetchChartData();
    }, [selectedPeriod]);

  return (
    <div style={{ marginTop: '20px' }}>
        <Row>
            <Col md={3} sm={6} xs={12}>
                <FormGroup>
                    <Label>Selecione o período:</Label>
                    <Input
                        type="select"
                        value={selectedPeriod}
                        onChange={(e) => setSelectedPeriod(e.target.value)}
                        >
                        {periods.map((p) => (
                            <option key={p.value} value={p.value}>
                            {p.label}
                            </option>
                        ))}
                    </Input>
                </FormGroup>
            </Col>
        </Row>

        <Row >
            {!loading && !error && (
            <>
                <Col style={{ textAlign: 'left'}}>
                    <strong>Total Receita: </strong>
                    {` ${totals.receita.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
                    <strong className="ms-4">Total Impressões:</strong> {totals.impressoes.toLocaleString('pt-BR')}
                </Col>
            </>
            )}
        </Row>
        <div id="chart">
                {loading && <div className="text-center p-5"><Spinner>Carregando...</Spinner></div>}
                {error && <Alert color="danger">{error}</Alert>}
                {!loading && !error && (
                    <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={350} />
                )}
            </div>
        <div id="html-dist"></div>
        
    </div>
  )
}

export default ChartView